import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/jex.webp';
import screenshot_target from '../../../images/letterfunnel/nickhillebrand.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Nick Hillebrand"
      firstname="Nick"
      companyname="Jex"
      competition="OnePeople en Bullhorn"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/nickhillebrand.js